import React from 'react';

const UnselectedRadio = ({ color = 'currentColor' }: { color: string }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1667 11.5002C20.1667 6.43755 16.0627 2.3335 11 2.3335C5.93743 2.3335 1.83337 6.43755 1.83337 11.5002C1.83337 16.5628 5.93743 20.6668 11 20.6668C16.0627 20.6668 20.1667 16.5628 20.1667 11.5002ZM3.43754 11.5002C3.43754 7.32351 6.82339 3.93766 11 3.93766C15.1767 3.93766 18.5625 7.32351 18.5625 11.5002C18.5625 15.6768 15.1767 19.0627 11 19.0627C6.82339 19.0627 3.43754 15.6768 3.43754 11.5002Z"
        fill={color}
      />
    </svg>
  );
};

export default UnselectedRadio;
